<template>
  <div
    v-if="horario.id"
    :class="[
      'mb-horario__container border-b border-gray-300',
      $attrs.class || '',
      horario.vigente && 'vigente',
      horario.primero && 'primero',
      horario.old && 'old',
    ]"
  >
    <div
      class="mb-horario__container-hora flex py-12 relative cursor-pointer"
      @click="toggleActivoHorario(horario.S)"
      @keydown.enter.space.prevent="toggleActivoHorario(horario.S)"
      role="button"
      tabindex="0"
      :aria-expanded="isActivoHorario === horario.S"
      aria-label="Ver detalle horario"
      data-testid="toggle-retorno"
      v-umami="{
        name: 'open-detail',
        data: `${horario.id}|${horario.S}-${horario.T}`,
      }"
    >
      <div
        class="mb-horario__loop items-center flex shrink-0 grow-0 basis-30 cursor-pointer"
      >
        <div class="flex items-center dark:text-gray-500 text-gray-500">
          <LucideMoreHorizontal :size="16" class="mr-4" />
          <span class="sr-only">Ver detalles horario {{ horario.S }}</span>
        </div>
      </div>
      <div
        class="mb-horario__salida flex-1 flex flex-col justify-center items-start"
      >
        <span>{{ horario.S }}</span>
      </div>
      <div
        class="mb-horario__llegada flex-1 flex flex-col justify-center items-start"
      >
        <span>{{ horario.T }}</span>
      </div>
      <div
        class="mb-horario__tiempo min-w-60 shrink-0 grow-0 basis-60 text-right pt-12"
      >
        <span class="block text-xs">{{ horario.V.join(', ') }}</span>
      </div>
      <div class="absolute top-0 right-0">
        <em
          hydrate-on-visible
          :class="[
            'text-xs block pr-2 pl-4 py-1',
            horario.old ? 'text-gray-200 bg-gray-900' : '',
            horario.vigente ? 'text-gray-200 bg-gray-900' : '',
            horario.primero
              ? 'text-gray-100 text-gray-800 bg-orange font-bold'
              : '',
          ]"
        >
          <template v-if="horario.old">Pasó </template>
          {{ horario.rel }}
        </em>
      </div>
    </div>

    <div
      :class="[
        'mb-horario__detalles dark:text-gray-300 dark:bg-azul-oscuro overflow-hidden transition-all duration-300',
        isActivoHorario === horario.S
          ? 'max-h-[800px] opacity-100'
          : 'max-h-0 opacity-0',
      ]"
    >
      <template v-if="isActivoHorario">
        <div class="py-12 px-12">
          <div class="flex items-center gap-4 mb-4">
            <div class="basis-24 shrink-0 flex items-center justify-center">
              <LucideClock :size="20" class="size-20! text-gray-500" />
            </div>
            <div class="text-sm leading-none">
              <span>Duración viaje: </span
              ><strong>{{ horario.duracion }}</strong>
            </div>
          </div>
          <div class="flex items-center gap-4 mb-4" v-if="tiempoTransbordo">
            <div
              class="basis-24 shrink-0 flex items-center text-gray-500 justify-center"
            >
              <LucideTrainFront :size="20" class="size-20!" />
            </div>
            <p class="leading-none text-sm">
              <span class="">Espera Transbordo: </span>
              <strong>
                {{ tiempoTransbordo }}
              </strong>
            </p>
          </div>
          <div class="flex items-center gap-4 mb-4">
            <div
              class="basis-24 shrink-0 flex items-center text-gray-500 justify-center"
            >
              <LucideCalendarClock :size="20" class="size-20!" />
            </div>
            <p class="leading-none text-sm">
              <span class="">Vigencia: </span>
              <span class="">
                {{ vigenciaHorarioStr }}
              </span>
            </p>
          </div>
        </div>
        <hr class="border-b border-dotted border-gray-700" />

        <div class="py-12" v-if="horario.T2 && horario.S2">
          <h3 class="font-semibold text-lg mb-4 pt-4 px-16">Recorrido</h3>
          <div class="flex">
            <div
              class="mb-horario__loop items-center flex shrink-0 grow-0 basis-60"
            ></div>
            <div class="flex-1 flex flex-col justify-center items-start">
              <div class="flex flex-col mb-8">
                <small class="leading-tight uppercase font-bold text-xs"
                  >Est. Salida</small
                >
                <span class="text-2xl leading-none">{{ horario.S }}</span>
              </div>
              <div class="flex flex-col">
                <small class="leading-tight uppercase font-bold text-xs"
                  >Est. Inter.</small
                >
                <span class="text-2xl leading-none" v-if="horario.S2">{{
                  horario.S2
                }}</span>
              </div>
            </div>
            <div class="flex-1 flex flex-col justify-center items-start">
              <div class="flex flex-col mb-8">
                <small class="leading-tight uppercase font-bold text-xs"
                  >Est. Inter.</small
                >
                <span class="text-2xl leading-none">{{ horario.T2 }}</span>
              </div>
              <div class="flex flex-col">
                <small class="leading-tight uppercase font-bold text-xs"
                  >Est. Llegada</small
                >
                <span class="text-2xl leading-none">{{ horario.T }}</span>
              </div>
            </div>
            <div class="min-w-60 shrink-0 grow-0 basis-60 text-right"></div>
          </div>
        </div>

        <div class="mb-horario__container-retorno py-12">
          <ul v-if="horariosRetorno.length" class="px-16 pb-16">
            <h3 class="font-semibold text-lg mb-4 pt-4">Horarios Retorno</h3>
            <li class="flex items-center mb-8">
              <div class="mb-salida flex-1">
                <small class="uppercase text-[0.6rem] leading-none"
                  >desde</small
                >
                <p class="font-sans text-sm leading-none">
                  {{ estacionLlegada }}
                </p>
              </div>
              <div class="mb-llegada flex-1">
                <small class="uppercase text-[0.6rem] leading-none"
                  >hasta</small
                >
                <p class="font-sans text-sm leading-none">
                  {{ estacionSalida }}
                </p>
              </div>
              <div
                class="mb-horario__tiempo min-w-60 shrink-0 grow-0 basis-60 leading-none text-right flex flex-col justify-center"
              />
            </li>
            <li
              v-for="horarioRetorno in horariosRetorno"
              :key="horarioRetorno.id"
            >
              <div
                class="mb-horario__container-hora flex items-center justify-between py-8 border-t light:border-gray-300 dark:border-gray-600"
              >
                <div class="mb-horario__salida flex-1 flex items-center return">
                  <span>{{ horarioRetorno.S }}</span>
                </div>
                <div
                  class="mb-horario__llegada flex-1 flex items-center return"
                >
                  <span>{{ horarioRetorno.T }}</span>
                </div>
                <div
                  class="mb-horario__tiempo min-w-60 shrink-0 grow-0 basis-60 leading-none text-right flex flex-col justify-center"
                >
                  <ClientOnly>
                    <em
                      hydrate-on-visible
                      class="text-gray-600 dark:text-gray-300 text-xs block mb-4"
                      >{{ horarioRetorno.rel }}</em
                    >
                    <span class="text-xs">{{
                      horarioRetorno.V.join(', ')
                    }}</span>
                  </ClientOnly>
                </div>
              </div>
            </li>
          </ul>
          <div v-else class="text-sm text-gray-500 italic">
            No hay horarios de retorno disponibles 😩
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
import { formatTime } from '~~/helpers';
import type { Horario } from '~~/interfaces';
const VIGENCIA = {
  'L-V': 'Lunes a Viernes',
  S: 'Sábado',
  D: 'Domingo',
};

const isActivoHorario = ref('');
type HorarioSingle = Horario & {
  id: string;
  S2?: string | undefined;
  rel: string;
};
const props = defineProps<{
  horario: HorarioSingle;
  horariosVuelta?: HorarioSingle[];
  estacionSalida: string;
  estacionLlegada: string;
}>();

const toggleActivoHorario = (horaSalida: string) => {
  isActivoHorario.value = isActivoHorario.value ? '' : horaSalida;
};

const horariosRetorno = computed(() => {
  const horariosRetornoArray = Array.from(props.horariosVuelta?.values() || []);

  const indexHorarioRetornoSiguiente = horariosRetornoArray.findIndex(
    (horarioRetorno) => horarioRetorno.S >= props.horario.T
  );

  return horariosRetornoArray
    .slice(indexHorarioRetornoSiguiente, indexHorarioRetornoSiguiente + 5)
    .filter(Boolean)
    .sort((a, b) => (a.id! > b.id! ? 1 : -1));
});

const vigenciaHorarioStr = computed(() => {
  return props.horario.V.map((day) => VIGENCIA[day]).join(', ');
});
const tiempoTransbordo = computed(() => {
  if (!props.horario.T2 || !props.horario.S2) return '';
  const today = new Date().toISOString().split('T')[0];
  const horaS2 = props.horario.S2;
  const horaT2 = props.horario.T2;
  const date1 = new Date(`${today}T${horaS2}`);
  const date2 = new Date(`${today}T${horaT2}`);

  const diff = Math.round((date2.getTime() - date1.getTime()) / 1000);

  return formatTime(diff).replace('dentro de ', '');
});

defineExpose({ toggleActivoHorario, isActivoHorario });
</script>

<style>
@reference '~/assets/css/tailwind.css'
.mb-horario__container .mb-horario__container-hora .mb-horario__salida,
.mb-horario__container .mb-horario__container-hora .mb-horario__llegada {
  line-height: 1;
  display: flex;
  align-items: center;
}

.mb-horario__container .mb-horario__container-hora .mb-horario__salida span,
.mb-horario__container .mb-horario__container-hora .mb-horario__llegada span {
  font-family: 'Roboto Mono', 'Roboto Mono Fallback', monospace;
  font-size: var(--text-2xl); /* 1.5rem = 24px */
  line-height: var(
    --tw-leading,
    var(--text-2xl--line-height) /* calc(2 / 1.5) ≈ 1.333333 */
  );
  display: block;
  --tw-font-weight: var(--font-weight-normal); /* 400 */
  font-weight: var(--font-weight-normal);
  --tw-leading: 1;
  line-height: 1;
}

.mb-horario__container:not(.vigente) {
  @apply text-gray-400;
}

.mb-horario__container.vigente {
  @apply text-gray-900;
}

.mb-horario__container.vigente.primero .mb-horario__salida:not(.return) span,
.mb-horario__container.vigente.primero .mb-horario__llegada:not(.return) span {
  @apply text-orange-700 dark:text-orange;
}

.dark .mb-horario__container {
  border-color: var(--color-gray-700);
  color: var(--color-gray-200);
}

.dark .mb-horario__container:not(.vigente) {
  color: var(--color-gray-500);
}

.dark .mb-horario__container.old {
  color: var(--color-gray-400);
}

.dark .mb-horario__container .mb-horario__tiempo em {
  color: var(--color-gray-300);
}
</style>
